define("shared/helpers/are-equal", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f
  /**
   * @module Helpers
   */
  /**
   * @class LaterHelpers
   * @extends Helpers
   */
  /**
   * Compare values of two arguments.
   *
   * @method are-equal
   */
  const areEqual = (0, _helper.helper)(_ref => {
    let [arg1, arg2] = _ref;
    return arg1 == arg2;
  });
  var _default = _exports.default = areEqual;
});